import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/home/index.vue";
import store from "../store/index";
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/index",
    component: Home,
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index/index.vue"),
      },
      {
        path: "/product-center/industry-AI",
        name: "industry-AI",
        component: () => import("@/views/product-center/industry-AI.vue"),
      },
      {
        path: "/product-center/AI-serve",
        name: "AI-serve",
        component: () => import("@/views/product-center/AI-serve.vue"),
      },
      {
        path: "/product-center/EDk",
        name: "EDk",
        component: () => import("@/views/product-center/EDK.vue"),
      },
      {
        path: "/product-center/GEDAM",
        name: "GEDAM",
        component: () => import("@/views/product-center/GEDAM.vue"),
      },
      {
        path: "/product-center/EDT",
        name: "EDT",
        component: () => import("@/views/product-center/EDT.vue"),
      },
      {
        path: "/success-cases",
        name: "success-cases",
        component: () => import("@/views/success-cases/index.vue"),
      },
      {
        path: "/success-cases/detail",
        name: "success-cases-detail",
        component: () => import("@/views/success-cases/detail.vue"),
      },
      {
        path: "/consulting-news",
        name: "consulting-news",
        component: () => import("@/views/consulting-news/index.vue"),
      },
      {
        path: "/consulting-news/detail",
        name: "news-detail",
        component: () => import("@/views/consulting-news/news-detail.vue"),
      },
      {
        path: "/my/company-profile",
        name: "company-profile",
        component: () => import("@/views/my/company-profile/index.vue"),
      },
      {
        path: "/my//core-team",
        name: "core-team",
        component: () => import("@/views/my/core-team/index.vue"),
      },
      {
        path: "/my//core-advantage",
        name: "core-advantage",
        component: () => import("@/views/my/core-advantages/idnex.vue"),
      },
      {
        path: "/my//development-history",
        name: "development-history",
        component: () => import("@/views/my/development-history/index.vue"),
      },
      {
        path: "/my//honor",
        name: "honor",
        component: () => import("@/views/my/honor/index.vue"),
      },
      {
        path: "/my/contant-us",
        name: "contant-us",
        component: () => import("@/views/my/contant-us/index.vue"),
      },
      {
        path: "/solution",
        name: "solution",
        component: () => import("@/views/solution/index.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
// 前置导航守卫
router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0;
  if (to.path.indexOf("/product-center") !== -1) {
    store.commit("setNavIndex", 1);
  } else if (to.path.indexOf("/solution") !== -1) {
    store.commit("setNavIndex", 2);
  } else if (to.path.indexOf("/success-cases") !== -1) {
    store.commit("setNavIndex", 3);
  } else if (to.path.indexOf("/consulting-news") !== -1) {
    store.commit("setNavIndex", 4);
  } else if (to.path.indexOf("/my") !== -1) {
    store.commit("setNavIndex", 5);
  } else {
    store.commit("setNavIndex", 0);
  }

  next();
});
export default router;
